module.exports = __webpack_public_path__ + "media/images/mobile-only/el-1-30b753bc706924de368f4d0c687378a6.png";